import { render } from "./PhotoAlbum.vue?vue&type=template&id=ccfbc9cc"
import script from "./PhotoAlbum.vue?vue&type=script&lang=js"
export * from "./PhotoAlbum.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./PhotoAlbum.vue?vue&type=style&index=0&id=ccfbc9cc&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script